import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.displaysteuerung-constants';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungDisplaysteuerungConstantsEffects {

    DisplaysteuerungConstants$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_DISPLAYSTEUERUNG_CONSTANTS),
        mergeMap((x: ac.GetDisplaysteuerungConstantsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getDisplaysteuerungConstants().pipe(
                map((result: any) => {
                    return new ac.GetDisplaysteuerungConstantsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetDisplaysteuerungConstantsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DisplaysteuerungTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DisplaysteuerungTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.DisplaysteuerungTemplatesService);
        }
        return this.service;
    }
}
